import { useCallback, useState } from "react";
import { useBackButtonStore } from "@/store/back-button-store";

interface UseVideoFullscreenProps {
  onToggle?: () => void;
}

export const useVideoFullscreen = ({ onToggle }: UseVideoFullscreenProps = {}) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const { push: pushBack, pop: popBack } = useBackButtonStore();

  const handleBack = useCallback(() => {
    setIsFullscreen(false);
    popBack();
  }, [popBack]);

  const toggleFullscreen = useCallback(
    (event?: React.MouseEvent) => {
      event?.stopPropagation();

      setIsFullscreen((prev) => {
        const next = !prev;

        if (next) {
          pushBack(handleBack);
        } else {
          popBack();
        }

        return next;
      });

      onToggle?.();
    },
    [handleBack, onToggle, popBack, pushBack]
  );

  return {
    isFullscreen,
    toggleFullscreen,
  };
};
